import { render } from "./Step3.vue?vue&type=template&id=45c3c7cc&scoped=true&ts=true"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"

import "./Step3.vue?vue&type=style&index=0&id=45c3c7cc&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c3c7cc"]])

export default __exports__